import { User } from '../models'
import { getCtCookie, updateCTCookie } from './cookies.helpers'

export const updateUserCookies = (user: User) => {
  updateCTCookie('ct-country', user?.country_code || getCtCookie('ct-country') || 'ES')
  updateCTCookie('ct-language', user?.language || getCtCookie('ct-language') || 'en')
  updateCTCookie('ct-currency', user?.currency_token_code || getCtCookie('ct-currency') || 'EUR')
}
